import { Component } from "react";
import { Dialog } from "primereact/dialog";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import { Divider } from "primereact/divider";

class PromiseWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = { show: false };
        this.dialogInstance = null;
        this.clear();
    }

    getPromiseAnswer() {
        if (this.pending && this.reject) this.reject(new Error("A new confirmation has started"));
        this.clear();
        return new Promise((resolve, reject) => {
            if (this.pending) reject(new Error("A new confirmation has started"));
            this.resolve = resolve;
            this.reject = reject;
            this.setState({ show: true });
        });
    }

    componentWillUnmount() {
        if (this.pending && this.reject) this.reject(new Error("Component umounted"));
        this.clear();
    }

    clear() {
        this.pending = false;
        this.resolve = null;
        this.reject = null;
    }

    renderDialog() {
        const { yesText, noText, headerText, contentText } = this.props;
        if (!this.state.show) return null;
        return (
            <Dialog header={headerText} className='dialog-prime'
                ref={dialog => (this.dialogInstance = dialog)}
                visible={this.state.show} showCloseIcon={false} closable={false}
                style={{width:"400px"}} baseZIndex={1048}
                footer={
                    <div>
                        <Divider />
                        <ButtonPrime label={yesText} onClick={() => {
                            this.resolve(true);
                            this.clear();
                            this.dialogInstance && this.dialogInstance.props.onHide();
                            this.setState({ show: false });
                        }} className="dialog-button dbtn-e-primary dbtn-primary"
                        />
                        <ButtonPrime label={noText} onClick={() => {
                            this.resolve(false);
                            this.clear();
                            this.dialogInstance && this.dialogInstance.props.onHide();
                            this.setState({ show: false });
                        }} className="dialog-button dbtn-e-flat"
                        />
                    </div>
                }
                onHide={() => {
                    if (this.pending && this.reject) {
                        this.reject(new Error("Modal closed"));
                        this.clear();
                    }
                    this.setState({ show: false });
                }}
            >
                {contentText}
            </Dialog>
        );
    }

    render() {
        return <div>{this.renderDialog()}</div>;
    }
}

export default PromiseWrapper;
